import React, { useState } from 'react';
import { Box, Container, Typography, useTheme, useMediaQuery } from '@mui/material';
import { Icon } from '@iconify/react';
import TopBar from '../components/TopBar';
import Sidebar from '../components/Sidebar';
import ReversalListsModal from '../components/ReversalListsModal';
interface ReversalListsProps {
  onLogout: () => void;
}
const ReversalLists: React.FC<ReversalListsProps> = ({
  onLogout
}) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  return <Box sx={{
    display: 'flex',
    width: '100%',
    minHeight: '100vh',
    backgroundColor: '#F8FAFC',
    overflow: 'hidden'
  }} data-id="element-4379" data-mp="2v9oiu3uqbpky">
      <TopBar onMenuClick={handleDrawerToggle} onLogout={onLogout} title="Reversal Lists" data-id="element-4380" data-mp="22mkjaeeeo3gk" />
      <Sidebar open={mobileOpen} onClose={handleDrawerToggle} activePage="reversal-lists" data-id="element-4381" data-mp="27k2hb9qvwy9s" />
      <Box component="main" sx={{
      flexGrow: 1,
      p: 2,
      width: {
        xs: '100%',
        sm: `calc(100% - 240px)`
      },
      maxWidth: '100%',
      ml: {
        xs: 0,
        sm: '240px'
      },
      mt: 8,
      overflow: 'hidden'
    }} data-id="element-4382" data-mp="2zygsvjut2bhm">
        <Box sx={{
        maxWidth: '100%'
      }} data-id="element-4383" data-mp="2m8n1atrx1d47">
          <Box sx={{
          display: 'flex',
          alignItems: 'center',
          mb: 2
        }} data-id="element-4384" data-mp="2h6xmd31kofau">
            <Icon icon="lucide:undo-2" width={28} height={28} color="#8B5CF6" data-id="element-4385" data-mp="2capco5659eb2" />
            <Typography variant="h5" component="h1" sx={{
            ml: 1.5,
            fontWeight: 600
          }} data-id="element-4386" data-mp="27bm5of6lsy0g">
              Reversal Upload History
            </Typography>
          </Box>
          <ReversalListsModal data-id="element-4387" data-mp="1zxlnhjl5lks7" />
        </Box>
      </Box>
    </Box>;
};
export default ReversalLists;